import React, { useMemo, useEffect, useRef } from "react";
import { ReferenceAutocompleteInput } from "ra-friendsofbabba";
import { useForm, useFormState } from "react-final-form";
import { get } from "lodash";

const UserFilteredInput = (props) => {
  const formState = useFormState();
  const form = useForm();
  const { researchProjectId } = useMemo(() => {
    const researchProjectId = get(
      formState.values,
      "research_project_id",
      null
    );
    return { researchProjectId };
  }, [formState]);

  const didMount = useRef(false);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    form.change("user_id", null);
  }, [form, researchProjectId]);

  return (
    <ReferenceAutocompleteInput
      {...props}
      reference="users"
      optionText="name"
      filter={{ research_project_id: researchProjectId }}
    />
  );
};
export default UserFilteredInput;
